import React from "react";

import { cn } from "@/utils/cn";

interface IBlinkerProps {
	className?: string;
}

export const Blinker: React.FC<IBlinkerProps> = ({ className }) => {
	return (
		<div
			style={{
				animation: "ping 2s cubic-bezier(0, 0, 0.2, 1) infinite",
			}}
			className={cn([
				"bg-primary-500 h-2 w-2 animate-ping rounded-full",
				className,
			])}
		/>
	);
};
